<template>
  <g v-if="lines.length" class="export-info" data-testid="export-info">
    <text
      v-for="(line, index) in lines"
      :key="line"
      data-testid="export-info-line"
      :x="10 * sizeScale"
      :y="(20 + index * 20) * sizeScale"
      :font-size="14 * sizeScale"
      :stroke-width="3 * sizeScale"
      stroke="white"
      fill="#333"
      font-family="sans-serif"
      font-weight="bold"
      paint-order="stroke fill"
    >
      {{ line }}
    </text>
  </g>
</template>

<i18n lang="yaml">
ja:
  export_info:
    facility: 管理施設名
    floor_plan: 図面
    period: 期間
    detection_filter: 検出種別
  detection_filter_label:
    exclude_misdetection: 誤検出を除外
    pickup_only: ピックアップのみ
    all: すべて
en:
  export_info:
    facility: Facility
    floor_plan: Floor Plan
    period: Period
    detection_filter: Detection Filter
  detection_filter_label:
    exclude_misdetection: Exclude false positives
    pickup_only: Pickup only
    all: All
</i18n>

<script>
export default {
  name: 'ExportInfo',
  props: {
    placeName: {
      type: String,
      default: '',
    },
    floorPlanName: {
      type: String,
      default: '',
    },
    selectedMonth: {
      type: String,
      default: '',
    },
    detectionFilter: {
      type: String,
      default: '',
    },
    sizeScale: {
      type: Number,
      default: 1.0,
    },
  },
  computed: {
    detectionFilterLabel() {
      if (!this.detectionFilter) return '';
      return this.$t(`detection_filter_label.${this.detectionFilter}`);
    },
    lines() {
      if (!this.placeName || !this.floorPlanName || !this.selectedMonth || !this.detectionFilterLabel) {
        return [];
      }
      return [
        `${this.$t('export_info.facility')}: ${this.placeName}`,
        `${this.$t('export_info.floor_plan')}: ${this.floorPlanName}`,
        `${this.$t('export_info.period')}: ${this.selectedMonth}`,
        `${this.$t('export_info.detection_filter')}: ${this.detectionFilterLabel}`,
      ];
    },
  },
};
</script>

<style scoped>
.export-info {
  visibility: hidden;
}
</style>
